import { AdminApi } from 'stylemix-vue-admin'

export default class PeriodPricingApi extends AdminApi {
  constructor(parameters = {}) {
    super('price-periods', parameters)
  }
}
